export default __webpack_public_path__ + "static/media/filter.018f3789.svg";